const RxFooter = () => {
  return (
    <>
      <div className="rx-footer">
        <div className="container">
          <div className="rx-footer-content">
            <h2>מידע שמסרת ותמסור ברצונך ובהסכמתך יישמר אצלנו וישמש את ואלור מוצרים חכמים בע"מ לצורך דיוור ישיר, ניתוח מידע ומתן השירותים. המידע יועבר לספקי החברה לצרכים האמורים. ללא מסירת המידע, ייתכן כי לא נוכל להעניק את השירותים, לרבות מתן זכות שימוש במערכת. ניתן לעיין במידע או לבקש את תיקונו באמצעות פניה לחברה . לשירותך, ואלור מוצרים חכמים בע"מ, לפנייה ניתן לשלוח מייל לכתובת: Support@hidoc.co.il</h2>
            <h2>Powered by Madanes</h2>

          </div>
        </div>
      </div>
    </>
  );
};

export default RxFooter;
